import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

export const downloadBase64File = (base64Data, contentType, filename) => {
  try {
    const byteCharacters = atob(base64Data);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type: contentType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename || "attachment";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (e) {
    console.error("Download failed:", e);
  }
};

export const printBase64File = (base64Data, contentType, filename) => {
  try {
    if (contentType === "application/pdf" || contentType === "pdf") {
      const byteCharacters = atob(base64Data);
      const byteArray = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      const printWindow = window.open(blobUrl);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
          URL.revokeObjectURL(blobUrl);
        };
      }
    } else if (contentType?.startsWith("image/")) {
      const url = `data:${contentType};base64,${base64Data}`;
      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.write(
          "<html><head><title>" +
            (filename || "attachment") +
            '</title></head><body style="margin:0;display:flex;justify-content:center;align-items:center;min-height:100vh">' +
            '<img src="' +
            url +
            '" style="max-width:100%;max-height:100vh;" onload="window.print();" />' +
            "</body></html>"
        );
        printWindow.document.close();
      }
    }
  } catch (e) {
    console.error("Print failed:", e);
  }
};

export const AttachmentActionButtons = ({
  base64Data,
  contentType,
  filename,
}) => {
  if (!base64Data) return null;
  return (
    <>
      <Tooltip title="Download">
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            downloadBase64File(base64Data, contentType, filename);
          }}
          sx={{
            color: "#fff",
            backgroundColor: "#125386",
            "&:hover": { backgroundColor: "#0e4270" },
            width: 30,
            height: 30,
          }}
        >
          <DownloadOutlinedIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Print">
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            printBase64File(base64Data, contentType, filename);
          }}
          sx={{
            color: "#fff",
            backgroundColor: "#125386",
            "&:hover": { backgroundColor: "#0e4270" },
            width: 30,
            height: 30,
          }}
        >
          <PrintOutlinedIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
    </>
  );
};

export const ModalActionButtons = ({ base64Data, contentType, filename }) => {
  if (!base64Data) return null;
  return (
    <>
      <Tooltip title="Download">
        <IconButton
          onClick={() => downloadBase64File(base64Data, contentType, filename)}
          sx={{
            color: "#125386",
            backgroundColor: "#e3f2fd",
            "&:hover": { backgroundColor: "#bbdefb" },
          }}
        >
          <DownloadOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Print">
        <IconButton
          onClick={() => printBase64File(base64Data, contentType, filename)}
          sx={{
            color: "#125386",
            backgroundColor: "#e3f2fd",
            "&:hover": { backgroundColor: "#bbdefb" },
          }}
        >
          <PrintOutlinedIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};
